import { ADMIN_ROLES, type Role } from "@/api/permissions";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  getLocalRole,
  isLocalRoleSwitchingEnabled,
  setLocalRole,
} from "@/auth/local-role";

/**
 * Local-dev only: simulate any admin role against the local backend, so the
 * role-gated UI can be exercised without an Entra login. Renders nothing when
 * the app is running against real MSAL auth.
 *
 * Switching reloads the page rather than invalidating queries. Everything
 * already in memory — whoami, every react-query entry, the metrics catalog —
 * was fetched as the previous role, and a reload is the only way to be
 * certain none of it survives into the new one.
 */
export function LocalRoleSwitcher() {
  if (!isLocalRoleSwitchingEnabled()) return null;

  const onChange = (value: string) => {
    setLocalRole(value as Role);
    window.location.reload();
  };

  return (
    <Select value={getLocalRole()} onValueChange={onChange}>
      <SelectTrigger
        size="sm"
        aria-label="Simulated admin role (local dev)"
        title="Simulated admin role (local dev)"
        className="w-[7.5rem]"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {ADMIN_ROLES.map((role) => (
          <SelectItem key={role} value={role}>
            {role}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
